var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.element.rootStyle },
    [
      !_vm.element.isPanel
        ? _c("survey-element", {
            key: _vm.element.id,
            style: _vm.element.getRootStyle(),
            attrs: {
              element: _vm.element,
              survey: _vm.survey,
              css: _vm.css,
              row: _vm.row,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.element.isPanel
        ? _c("survey-panel", {
            key: _vm.element.id,
            attrs: { question: _vm.element, css: _vm.css },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }